// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/datapipelines/v1/data_pipelines.proto" (package "viam.app.datapipelines.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { DataPipelinesService } from "./data_pipelines";
import type { ListDataPipelineRunsResponse } from "./data_pipelines";
import type { ListDataPipelineRunsRequest } from "./data_pipelines";
import type { DisableDataPipelineResponse } from "./data_pipelines";
import type { DisableDataPipelineRequest } from "./data_pipelines";
import type { EnableDataPipelineResponse } from "./data_pipelines";
import type { EnableDataPipelineRequest } from "./data_pipelines";
import type { DeleteDataPipelineResponse } from "./data_pipelines";
import type { DeleteDataPipelineRequest } from "./data_pipelines";
import type { RenameDataPipelineResponse } from "./data_pipelines";
import type { RenameDataPipelineRequest } from "./data_pipelines";
import type { CreateDataPipelineResponse } from "./data_pipelines";
import type { CreateDataPipelineRequest } from "./data_pipelines";
import type { ListDataPipelinesResponse } from "./data_pipelines";
import type { ListDataPipelinesRequest } from "./data_pipelines";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetDataPipelineResponse } from "./data_pipelines";
import type { GetDataPipelineRequest } from "./data_pipelines";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * DataPipelinesService is used to manage data pipelines.
 *
 * @generated from protobuf service viam.app.datapipelines.v1.DataPipelinesService
 */
export interface IDataPipelinesServiceClient {
    /**
     * GetDataPipeline retrieves a specific data pipeline by its id.
     *
     * @generated from protobuf rpc: GetDataPipeline(viam.app.datapipelines.v1.GetDataPipelineRequest) returns (viam.app.datapipelines.v1.GetDataPipelineResponse);
     */
    getDataPipeline(input: GetDataPipelineRequest, options?: RpcOptions): UnaryCall<GetDataPipelineRequest, GetDataPipelineResponse>;
    /**
     * ListDataPipelines returns a list of data pipelines based on organization id.
     *
     * @generated from protobuf rpc: ListDataPipelines(viam.app.datapipelines.v1.ListDataPipelinesRequest) returns (viam.app.datapipelines.v1.ListDataPipelinesResponse);
     */
    listDataPipelines(input: ListDataPipelinesRequest, options?: RpcOptions): UnaryCall<ListDataPipelinesRequest, ListDataPipelinesResponse>;
    /**
     * CreateDataPipeline creates a new data pipeline with the provided configuration.
     *
     * @generated from protobuf rpc: CreateDataPipeline(viam.app.datapipelines.v1.CreateDataPipelineRequest) returns (viam.app.datapipelines.v1.CreateDataPipelineResponse);
     */
    createDataPipeline(input: CreateDataPipelineRequest, options?: RpcOptions): UnaryCall<CreateDataPipelineRequest, CreateDataPipelineResponse>;
    /**
     * RenameDataPipeline changes a data pipeline's name.
     *
     * @generated from protobuf rpc: RenameDataPipeline(viam.app.datapipelines.v1.RenameDataPipelineRequest) returns (viam.app.datapipelines.v1.RenameDataPipelineResponse);
     */
    renameDataPipeline(input: RenameDataPipelineRequest, options?: RpcOptions): UnaryCall<RenameDataPipelineRequest, RenameDataPipelineResponse>;
    /**
     * DeleteDataPipeline deletes a data pipeline from the database.
     *
     * @generated from protobuf rpc: DeleteDataPipeline(viam.app.datapipelines.v1.DeleteDataPipelineRequest) returns (viam.app.datapipelines.v1.DeleteDataPipelineResponse);
     */
    deleteDataPipeline(input: DeleteDataPipelineRequest, options?: RpcOptions): UnaryCall<DeleteDataPipelineRequest, DeleteDataPipelineResponse>;
    /**
     * EnableDataPipeline enables a data pipeline.
     *
     * @generated from protobuf rpc: EnableDataPipeline(viam.app.datapipelines.v1.EnableDataPipelineRequest) returns (viam.app.datapipelines.v1.EnableDataPipelineResponse);
     */
    enableDataPipeline(input: EnableDataPipelineRequest, options?: RpcOptions): UnaryCall<EnableDataPipelineRequest, EnableDataPipelineResponse>;
    /**
     * DisableDataPipeline disables a data pipeline.
     *
     * @generated from protobuf rpc: DisableDataPipeline(viam.app.datapipelines.v1.DisableDataPipelineRequest) returns (viam.app.datapipelines.v1.DisableDataPipelineResponse);
     */
    disableDataPipeline(input: DisableDataPipelineRequest, options?: RpcOptions): UnaryCall<DisableDataPipelineRequest, DisableDataPipelineResponse>;
    /**
     * ListDataPipelineRuns lists the runs of a data pipeline.
     *
     * @generated from protobuf rpc: ListDataPipelineRuns(viam.app.datapipelines.v1.ListDataPipelineRunsRequest) returns (viam.app.datapipelines.v1.ListDataPipelineRunsResponse);
     */
    listDataPipelineRuns(input: ListDataPipelineRunsRequest, options?: RpcOptions): UnaryCall<ListDataPipelineRunsRequest, ListDataPipelineRunsResponse>;
}
/**
 * DataPipelinesService is used to manage data pipelines.
 *
 * @generated from protobuf service viam.app.datapipelines.v1.DataPipelinesService
 */
export class DataPipelinesServiceClient implements IDataPipelinesServiceClient, ServiceInfo {
    typeName = DataPipelinesService.typeName;
    methods = DataPipelinesService.methods;
    options = DataPipelinesService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * GetDataPipeline retrieves a specific data pipeline by its id.
     *
     * @generated from protobuf rpc: GetDataPipeline(viam.app.datapipelines.v1.GetDataPipelineRequest) returns (viam.app.datapipelines.v1.GetDataPipelineResponse);
     */
    getDataPipeline(input: GetDataPipelineRequest, options?: RpcOptions): UnaryCall<GetDataPipelineRequest, GetDataPipelineResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDataPipelineRequest, GetDataPipelineResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListDataPipelines returns a list of data pipelines based on organization id.
     *
     * @generated from protobuf rpc: ListDataPipelines(viam.app.datapipelines.v1.ListDataPipelinesRequest) returns (viam.app.datapipelines.v1.ListDataPipelinesResponse);
     */
    listDataPipelines(input: ListDataPipelinesRequest, options?: RpcOptions): UnaryCall<ListDataPipelinesRequest, ListDataPipelinesResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListDataPipelinesRequest, ListDataPipelinesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * CreateDataPipeline creates a new data pipeline with the provided configuration.
     *
     * @generated from protobuf rpc: CreateDataPipeline(viam.app.datapipelines.v1.CreateDataPipelineRequest) returns (viam.app.datapipelines.v1.CreateDataPipelineResponse);
     */
    createDataPipeline(input: CreateDataPipelineRequest, options?: RpcOptions): UnaryCall<CreateDataPipelineRequest, CreateDataPipelineResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateDataPipelineRequest, CreateDataPipelineResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * RenameDataPipeline changes a data pipeline's name.
     *
     * @generated from protobuf rpc: RenameDataPipeline(viam.app.datapipelines.v1.RenameDataPipelineRequest) returns (viam.app.datapipelines.v1.RenameDataPipelineResponse);
     */
    renameDataPipeline(input: RenameDataPipelineRequest, options?: RpcOptions): UnaryCall<RenameDataPipelineRequest, RenameDataPipelineResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<RenameDataPipelineRequest, RenameDataPipelineResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteDataPipeline deletes a data pipeline from the database.
     *
     * @generated from protobuf rpc: DeleteDataPipeline(viam.app.datapipelines.v1.DeleteDataPipelineRequest) returns (viam.app.datapipelines.v1.DeleteDataPipelineResponse);
     */
    deleteDataPipeline(input: DeleteDataPipelineRequest, options?: RpcOptions): UnaryCall<DeleteDataPipelineRequest, DeleteDataPipelineResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteDataPipelineRequest, DeleteDataPipelineResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * EnableDataPipeline enables a data pipeline.
     *
     * @generated from protobuf rpc: EnableDataPipeline(viam.app.datapipelines.v1.EnableDataPipelineRequest) returns (viam.app.datapipelines.v1.EnableDataPipelineResponse);
     */
    enableDataPipeline(input: EnableDataPipelineRequest, options?: RpcOptions): UnaryCall<EnableDataPipelineRequest, EnableDataPipelineResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<EnableDataPipelineRequest, EnableDataPipelineResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DisableDataPipeline disables a data pipeline.
     *
     * @generated from protobuf rpc: DisableDataPipeline(viam.app.datapipelines.v1.DisableDataPipelineRequest) returns (viam.app.datapipelines.v1.DisableDataPipelineResponse);
     */
    disableDataPipeline(input: DisableDataPipelineRequest, options?: RpcOptions): UnaryCall<DisableDataPipelineRequest, DisableDataPipelineResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<DisableDataPipelineRequest, DisableDataPipelineResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListDataPipelineRuns lists the runs of a data pipeline.
     *
     * @generated from protobuf rpc: ListDataPipelineRuns(viam.app.datapipelines.v1.ListDataPipelineRunsRequest) returns (viam.app.datapipelines.v1.ListDataPipelineRunsResponse);
     */
    listDataPipelineRuns(input: ListDataPipelineRunsRequest, options?: RpcOptions): UnaryCall<ListDataPipelineRunsRequest, ListDataPipelineRunsResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListDataPipelineRunsRequest, ListDataPipelineRunsResponse>("unary", this._transport, method, opt, input);
    }
}
